import { IRootState } from '../../../store'
import { IPTSOptionsState } from '../store/options.types'

export const getPtsOptionsSelector = (state: IRootState): IPTSOptionsState => state.options.ptsOptions
